var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "#A8ABC2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "IONIcon/A/arrow",
    d: "M1.29274 8.92381C0.575755 8.45057 0.21726 8.21395 0.0883223 7.91982C-0.0294412 7.65118 -0.0294422 7.34882 0.0883223 7.08018C0.21726 6.78605 0.575754 6.54943 1.29274 6.07619L9.14639 0.892517C10.0607 0.28903 10.5179 -0.0127135 10.8979 0.000410322C11.2436 0.0123482 11.5651 0.172734 11.7722 0.436654C12 0.726791 12 1.25663 12 2.31632L12 12.6837C12 13.7434 12 14.2732 11.7722 14.5633C11.5651 14.8273 11.2436 14.9877 10.8979 14.9996C10.5179 15.0127 10.0607 14.711 9.14639 14.1075L1.29274 8.92381Z",
    fill: "#A8ABC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkCollapse);
export default __webpack_public_path__ + "static/media/darkCollapse.487d99cf8d9e45eaa4fb6a2fa3e04f71.svg";
export { ForwardRef as ReactComponent };